goog.provide("shadow.js.shim.module$$mui$material$Typography");
goog.provide("module$shadow_js_shim_module$$mui$material$Typography");
shadow.js.shim.module$$mui$material$Typography = shadow.js.nativeProvides["@mui/material/Typography"] = shadow$bridge("@mui/material/Typography");
module$shadow_js_shim_module$$mui$material$Typography.default = shadow.js.shim.module$$mui$material$Typography;
